import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { ConfirmDialog } from '../../../../components/confirm-dialog/confirm-dialog';
import { SocialProviderUnitDto } from '../../../../api-service/clients';
import { ServiceProviderUnitSelect } from './service-provider-unit-select';

interface ServiceProviderUnitRequiredModalProps {
  open: boolean;
  onClose: () => void;
  serviceProviderUnits: SocialProviderUnitDto[] | undefined;
  onSelectUnit: (unitId: string) => void;
}

export function ServiceProviderUnitRequiredModal({ open, onClose, serviceProviderUnits, onSelectUnit }: ServiceProviderUnitRequiredModalProps) {
  const [selectedUnitId, setSelectedUnitId] = useState<string>('');

  // Auto-select first unit when modal opens
  useEffect(() => {
    if (open && serviceProviderUnits && serviceProviderUnits.length > 0 && !selectedUnitId) {
      setSelectedUnitId(serviceProviderUnits[0].id ?? '');
    }
  }, [open, serviceProviderUnits, selectedUnitId]);

  const handleConfirm = () => {
    if (selectedUnitId) {
      onSelectUnit(selectedUnitId);
      onClose();
    }
  };

  return (
    <ConfirmDialog
      type="info"
      title={serviceProviderUnits && serviceProviderUnits.length > 1 ? 'Vælg udførerenhed' : 'Du har ikke adgang til nogle udførerenheder'}
      open={open}
      onConfirmClick={handleConfirm}
      onCancelClick={onClose}
      confirmButtonText="OK"
      cancelButtonText="Annuller"
      disableBackdropClick
    >
      {serviceProviderUnits && serviceProviderUnits.length > 1 && (
        <Box sx={{ minWidth: 300, marginTop: 2 }}>
          <ServiceProviderUnitSelect value={selectedUnitId} onChange={setSelectedUnitId} serviceProviderUnits={serviceProviderUnits} />
        </Box>
      )}
    </ConfirmDialog>
  );
}
